import { FormattedMessage } from "react-intl";
import {
  agencyType,
  workWithStatisticsOptions,
} from "constants/Defaults.js";
import NationalTextField from "./NationalTextField";
import NationalSelectField from "./NationalSelectField";

export default function EmployerDataSection({
  register,
  errors,
  dir,
  currentLocale,
}) {
  return (
    <div className="data-form">
      <h5
        className="fw-bold mb-4 text-decoration-underline"
        style={{ color: "var(--main-color)" }}
      >
        <FormattedMessage id="employer-data" />
      </h5>

      <NationalSelectField
        register={register}
        name="workSource"
        labelId="employer"
        dir={dir}
        currentLocale={currentLocale}
        options={agencyType}
      />
      <NationalTextField
        register={register}
        name="workPostalNumber"
        labelId="postalCode"
        error={errors?.workPostalNumber}
      />
      <NationalTextField
        register={register}
        name="workAddress"
        labelId="empolyerAddress"
        error={errors?.workAddress}
      />
      <NationalTextField
        register={register}
        name="workPhone"
        labelId="empolyerPhone"
        type="tel"
        error={errors?.workPhone}
      />
      <NationalTextField
        register={register}
        name="jobTitle"
        labelId="jobTitle"
        error={errors?.jobTitle}
      />
      <NationalTextField
        register={register}
        name="jobRanking"
        labelId="jobClass"
        error={errors?.jobRanking}
      />
      <NationalTextField
        register={register}
        name="workNature"
        labelId="workNature"
        error={errors?.workNature}
      />
      <NationalSelectField
        register={register}
        name="workWithStatistics"
        labelId="connectionValue"
        dir={dir}
        currentLocale={currentLocale}
        options={workWithStatisticsOptions}
      />
      <NationalTextField
        register={register}
        name="currentWorkDuration"
        labelId="durationWork"
        error={errors?.currentWorkDuration}
      />
    </div>
  );
}
